import { render, staticRenderFns } from "./WonderStrategyPanorama.vue?vue&type=template&id=ffc036e2&scoped=true"
import script from "./WonderStrategyPanorama.vue?vue&type=script&lang=js"
export * from "./WonderStrategyPanorama.vue?vue&type=script&lang=js"
import style0 from "./WonderStrategyPanorama.vue?vue&type=style&index=0&id=ffc036e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc036e2",
  null
  
)

export default component.exports